// extracted by mini-css-extract-plugin
export default {"EmptyBank":"EmptyBank_EmptyBank__cZSUj","SubText":"EmptyBank_SubText__ew++y"};